import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { TypedFormBuilder } from '@assetaccountant/core/utils/typed-forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LeanCalendarPeriod } from '../calendar-selector.component';

@Component({
  selector: 'app-select-period-modal',
  templateUrl: './select-period-modal.component.html',
  styleUrls: ['./select-period-modal.component.scss'],
  standalone: false,
})
export class SelectPeriodModalComponent implements OnInit {
  @Input() currentStartDate: string;
  @Input() currentEndDate: string;

  @Input() calendarPeriods: LeanCalendarPeriod[];

  @Input() maxEndDate: string;

  @Output() selectPeriod = new EventEmitter<{ startDate: string; endDate: string }>();

  form = this.fb.group({
    startDate: ['', Validators.required],
    endDate: ['', Validators.required],
  });

  get formIsInvalid() {
    return this.form.invalid;
  }

  endDates: string[] = [];
  startDates: string[] = [];

  showMaxDateWarning = false;
  resetEndDate = false;

  constructor(
    public modal: NgbActiveModal,
    @Inject(LOCALE_ID) public locale: string,
    private fb: TypedFormBuilder,
  ) {}

  ngOnInit() {
    this.endDates = this.calendarPeriods.map(cp => cp.endDate);
    this.startDates = this.calendarPeriods.map(cp => cp.startDate);
    this.initForm();
    this.form.controls.endDate.setValidators(Validators.required);
    this.form.controls.startDate.setValidators(Validators.required);
  }

  save() {
    this.selectPeriod.emit({
      startDate: this.form.controls.startDate.value,
      endDate: this.form.controls.endDate.value,
    });
    return true;
  }

  private initForm() {
    this.form.reset({
      startDate: this.currentStartDate,
      endDate: this.currentEndDate,
    });
    if (this.maxEndDate) {
      this.form.controls.endDate.valueChanges.subscribe(value => {
        if (Date.parse(value) > Date.parse(this.maxEndDate)) {
          this.form.controls.endDate.setValue(this.maxEndDate, { emitEvent: false });
          this.resetEndDate = true;
          setTimeout(() => {
            this.showMaxDateWarning = true;
            this.resetEndDate = false;
          }, 0);
        } else {
          this.showMaxDateWarning = false;
        }
      });
    }
  }
}

export function dateRangeValidator(
  startDate: AbstractControl,
  comparerFunc: (end, start) => boolean,
): ValidatorFn {
  return (endDate: AbstractControl): { [key: string]: any } => {
    if (comparerFunc(endDate.value, startDate.value)) {
      return { invalidDateRange: { value: null } };
    }
    return {};
  };
}
